import React, { useEffect, useMemo, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import AWS from 'aws-sdk';

import moment from 'utils/moment';
import styles from './form.module.scss';
import Auth from '../../../../utils/Auth';
import Loading from '../../../../components/loading';
import Button from '../../../../components/button/button';
import HeaderBack from '../../../../components/headerBack';
import permitIcon from '../../../../icons/PERMITMODULE.png';
import SectionHeader from '../../../../components/sectionHeader';

import { GetFileName, S3Uploads } from '../../../services';
import { getThreeLetterCountryCode } from '../../../../utils/helpers';
import { clearDetailsState, clearDraftState, clearState, fetchspecificAdpLogs, getAdpCategories, getAdpDefaultFields, initiateApplication,
  initiateDraftPermit, deleteSaveAsDraftAdpLog, handleClearApprovedApplicationState
 } from '../../redux/action';
import {
  adpDefaultIDs,
  getCusAns,
  getDefAnswer,
  getValue,
  renderFieldComponent,
  valueType,
  filterCustomFieldAnswers,
  handleSignature,
  getAttachmentIds,
  isEmptyValue
} from '../../components/PermitData';
import FormattedMessageWithClass from '../../../../components/formattedMessageWithClass';
import { SaveAlert } from '../../components/ActionCompo';
import DeleteConfirmation from '../../../../components/deleteConfirmation/deleteConfirmation';
import { PERMIT_ALREADY_RENEWED } from '../../constant';

const RenewalAdminForm = () => {
  const history = useHistory();
  const params = useParams();
  const { id, installationId, airportCode } = params;

  const dispatch = useDispatch();
  const userProfile = useSelector(data => data?.auth?.profile);
  const userData = useSelector(data => data.permitManagement?.specificLog);
  const countryCode = useSelector(data => data?.auth?.profile?.portal_airport?.country_code);
  const ordering = useSelector(state => state.permitManagement?.AdpOrder);
  const customFields = useSelector(state => state.permitManagement?.AdpCSchema);
  const defaultFields = useSelector(state => state.permitManagement?.AdpDSchema);
  const adpCategories = useSelector(state => state?.permitManagement?.adpCategories);
  const renewalFields = useSelector(state => state.permitManagement?.adpRenewalFields);
  const oldCustomFields = useSelector(data => data?.permitManagement?.adpCSchema);
  const submissionStatus = useSelector(state => state.permitManagement?.adpInitiationStatus);
  const errorResponse = useSelector(states => states.permitManagement?.errorResponse);
  const getSchemaStatus = useSelector(states => states?.permitManagement?.adpGetSchemaStatus);
  const notes = useSelector(data => data?.permitManagement?.adpSchema?.default_fields?.notes);
  const initiateDraftApplicationAction = useSelector(state => state?.permitManagement?.initiateDraftApplicationAction);
  const reqAttach = useSelector(data => data?.permitManagement?.adpSchema?.default_fields?.required_attachements);
  const actionDeleteDraftApplication = useSelector(states => states?.permitManagement?.actionDeleteDraftADPApplication);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [alert, setAlert] = useState(false);
  const [load, setLoad] = useState(false);
  const [isAlreadySubmited, setIsAlreadySubmited] = useState(false);
  const [state, setState] = useState({
    answers: {},
    preAnswers: {},
    loader: false,
    formErrors: false,
    dateError: false
  });
  const [errors, setErrors] = useState({});
  const [reqErrors, setReqErrors] = useState({});
  const [allFields, setAllFields] = useState([]);
  const [countryState, setCountryState] = useState([]);
  const [mergedFields, setMergedFields] = useState([]);
  const [conditionalFields, setConditionalFields] = useState({});
  const [initial, setInitial] = useState({
    init: true,
    render1: false,
    render2: false,
    render3: false,
    renderForAttachments: false
  });
  const [renewalErrors, setRenewalErrors] = useState({});

  const isIssuingAuthorityDisabled = defaultFields
    ?.some(field => field.id === 'issusing_authority' && field.isDisabled);

  useEffect(() => {
    if (actionDeleteDraftApplication.success === true) {
      goToLogs();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, actionDeleteDraftApplication]);

  useEffect(() => {
    if (submissionStatus.error === true && errorResponse === PERMIT_ALREADY_RENEWED) {
      setIsAlreadySubmited(true);
    }
  }, [errorResponse, submissionStatus]);

  const initialRender = () => {
    if (initial.init) {
      dispatch(fetchspecificAdpLogs(id));
      dispatch(getAdpCategories(true));
      dispatch(getAdpDefaultFields());
      setInitial(prev => ({ ...prev, init: false }));
    }
  };

  useEffect(() => { // we should not send prev_permit key to backend
    if (userData && Object.keys(userData || {})?.length > 0 && !Object.keys(state.preAnswers || {})?.length > 0) {
      const userDataFilterPrevPermit={};
      Object.keys(userData).forEach((key) => {
     if ((key !== 'prev_permit') && (key !== 'initiated_to')) {
       userDataFilterPrevPermit[key]=userData[key];
     }
   });
      setState(prev => ({ ...prev,
        preAnswers: { ...prev.preAnswers, ...userDataFilterPrevPermit } }));
    }
  }, [userData, state.preAnswers]);

  useEffect(() => {
    if (defaultFields && Object.keys(userData || {})?.length > 0) {
      const combinedFields = [...defaultFields, ...customFields];
      let Fields;
      let condFields = {};
      let fieldErros = { ...errors };
      const filteredFields = combinedFields?.filter(field => field?.id !== 'signature' && !field?.isDisabled);
      if (ordering?.length) { // sorted - if ordering
        Fields = ordering
          .map(orderId => filteredFields.find(field => field.id === orderId))
          .filter(field => field); // Remove undefined entries if any
      } else {
        Fields = filteredFields; // without sorted - if no ordering
      }
      setMergedFields(Fields);
      setInitial(prev => ({ ...prev, render1: true }));
      Fields.forEach((ele) => {
        if (ele.conditional) { // check the conditional fields
          if (condFields[ele.conditional_field.key]) {
            condFields[ele?.conditional_field?.key] = [...condFields[ele?.conditional_field?.key], ele];
          } else {
            condFields[ele?.conditional_field?.key] = [ele];
          }
        } else {
          fieldErros = { ...fieldErros, [ele.id]: ele.required };
          }
      });
      setConditionalFields(condFields);
      setErrors(fieldErros);
      setState(prev => ({ ...prev, loader: false }));
    } else {
      initialRender();
      setState(prev => ({ ...prev, loader: true }));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultFields, id, dispatch, userData]);

  // country code api calling
  useEffect(() => {
    if (defaultFields?.length) {
      if (!isIssuingAuthorityDisabled) {
        const getConfig = () => {
          const key = `cognito-idp.${process.env.REACT_APP_REGION}.amazonaws.com/${process.env.REACT_APP_USER_POOL_ID}`;
          AWS.config.update({
            region: process.env.REACT_APP_REGION,
            credentials: new AWS.CognitoIdentityCredentials({
              IdentityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
              Logins: {
                [key]: Auth.getInstance().getIDToken()
              }
            })
          });
          return AWS.config.credentials.getPromise();
        };
        getConfig();

        const docClient = new AWS.DynamoDB.DocumentClient({ region: process.env.REACT_APP_REGION });
        const threeCharCode = getThreeLetterCountryCode(countryCode);
        const param = {
          TableName: 'aeros_countries_states',
          KeyConditionExpression: 'country_large_code = :country_large_code',
          ExpressionAttributeValues: {
            ':country_large_code': threeCharCode
          }
        };
        docClient.query(param).promise().then((res) => {
          setCountryState(res.Items);
        });
      }
    }
  }, [defaultFields, countryCode, isIssuingAuthorityDisabled]);

  // set the country states to issuing_authority field
  useEffect(() => {
    const mapStateToKeyValue = stateList => stateList?.map(each => ({
        key: each?.state,
        value: each?.state
      }));
    const updateIssuingAuthorityField = (ele, countryStates) => {
      if (ele.id === 'issusing_authority') {
        return {
          ...ele,
          values: mapStateToKeyValue(countryStates),
          default_value: {}
        };
      }
      return ele;
    };
    const setIssuingAuthorityValues = () => {
      const updatedFields = mergedFields?.map(ele => updateIssuingAuthorityField(ele, countryState));
      setAllFields(updatedFields);
      setInitial(prev => ({ ...prev, render1: false, render2: true }));
    };
    if (!isIssuingAuthorityDisabled) {
      if (mergedFields?.length > 0 && countryState?.length > 0 && initial.render1) {
        setIssuingAuthorityValues();
      }
    } else {
      setAllFields(mergedFields);
      setInitial(prev => ({ ...prev, render1: false, render2: true }));
    }
  }, [mergedFields, countryState, initial.render1, isIssuingAuthorityDisabled]);

  useEffect(() => {
    const render = initial.render2 && allFields?.length > 0 && Object.keys(state.preAnswers || {})?.length > 0;
    if (!render) return;

    const updatedPreAnswers = { ...state.preAnswers };
    const selectFields = allFields.filter(f => f.type === 'select' && !f.isDisabled);
    const disableFields = defaultFields?.filter(f => adpDefaultIDs.includes(f.id) && f.isDisabled);

    // Handle select fields with invalid answers
    if (selectFields?.length) {
      selectFields.forEach((field) => {
        const validValues = field.values?.map(v => v.value) || [];
        const isDefaultField = adpDefaultIDs.includes(field.id);
        const answer = isDefaultField ? updatedPreAnswers[field.id] : updatedPreAnswers.response?.[field.id];

        if (!validValues.includes(answer)) {
          if (isDefaultField) {
            delete updatedPreAnswers[field.id];
          } else if (updatedPreAnswers.response?.[field.id]) {
            delete updatedPreAnswers.response[field.id];
          }
        }
      });
    }
    // Remove disabled fields
    if (disableFields?.length) disableFields.forEach(field => delete updatedPreAnswers[field.id]);

    // Update state
    setState(prev => ({
      ...prev,
      preAnswers: {
        ...updatedPreAnswers
      }
    }));
    setInitial(prev => ({ ...prev, render2: false, render3: true }));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initial.render2, defaultFields, allFields, state.preAnswers]);

  useEffect(() => {
    const hasPreAnswers = Object.keys(state.preAnswers || {}).length > 0;
    const hasNewSchema = Array.isArray(reqAttach) && reqAttach.length > 0;

    if (!initial.render3) return;
    if (!hasPreAnswers || !hasNewSchema) return;

    ['schema', 'signature', 'work_flow', 'training', 'offline_training', 'comment']
      .forEach(e => delete state.preAnswers[e]);

    const attachmentLookup = userData?.attachments?.reduce((acc, item) => {
      acc[item.attachment_id] = item;
      return acc;
    }, {});

    const oldReqMapped = Object.entries(userData.req_attachments || {}).reduce((acc, [key, ids]) => {
      const normalizedName = key.replace(/_attachments$/i, '').trim().toLowerCase();
      acc[normalizedName] = ids.map(i => attachmentLookup[i]).filter(Boolean);
      return acc;
    }, {});

    const newReqAttachments = reqAttach?.reduce((acc, item) => {
      const normalizedName = item.attachmentName.trim().toLowerCase();
      acc[`${item.attachmentName}_attachments`] = oldReqMapped[normalizedName] || [];
      return acc;
    }, {});

    const reqAttachObjects = Object.values(newReqAttachments).flat();
    const photoObjects = userData.photo || [];

    const modifiedAttachments = Array.from(
      new Map([...reqAttachObjects, ...photoObjects].map(obj => [obj.attachment_id, obj])).values()
    );

    const filteredAnswers = filterCustomFieldAnswers(oldCustomFields, customFields, userData.response);

    setState(prev => ({
      ...prev,
      answers: {
        ...prev.preAnswers,
        ...prev.answers,
        req_attachments: newReqAttachments,
        attachments: modifiedAttachments,
        photo: photoObjects,
        use_prev_badge: false,
        response: filteredAnswers
      }
    }));

    setInitial(prev => ({ ...prev, render3: false, renderForAttachments: true }));
  }, [initial.render3, state.preAnswers, state.answers, customFields, oldCustomFields, userData, reqAttach]);

  useEffect(() => {
    if (userData?.status === 14 && initial.renderForAttachments && Object.keys(state.preAnswers)?.length > 0) {
      const all_attachments = userData?.attachments?.reduce((acc, obj) => ({ ...acc, [obj.attachment_id]: obj }), {});
      const requireAttachments = userData?.req_attachments
        && Object.keys(userData?.req_attachments)
        .reduce((acc, key) => ({ ...acc, [key]: userData?.req_attachments[key].map(att => all_attachments[att]) }), {});
      const sign = userData.signature;
      const isEmptySignature = (Array.isArray(sign) && sign.length === 0)
        || (Array.isArray(sign) && sign.length === 1 && Object.keys(sign[0]).length === 0);
      setState(prev => ({ ...prev,
        answers: {
          ...prev.preAnswers,
          ...prev.answers,
          req_attachments: { ...requireAttachments },
          photo: userData?.photo,
          signature: isEmptySignature ? null : userData?.signature,
          attachments: userData?.attachments
        } }));
      setInitial(prev => ({ ...prev, renderForAttachments: false }));
    }
  }, [state.preAnswers, initial.renderForAttachments, userData]);

  // clear state on unmount
  useEffect(() => () => {
      dispatch(clearDetailsState());
      dispatch(handleClearApprovedApplicationState());
      setState(prev => ({ ...prev, answers: {}, preAnswers: {}, loader: false }));
    },
   [dispatch]);

    // Memoize newFieldErrors calculation outside of useEffect
    const newFieldErrors = useMemo(() => allFields
    .filter(fd => !fd.conditional && fd.type !== 'header' && fd.required)
    .reduce((acc, ele) => {
      let hasError;
      if (adpDefaultIDs.includes(ele.id)) {
        hasError = !state.answers[ele.id];
      } else if (ele.type === 'attachments') {
        hasError = !state.answers?.response?.[ele.id]?.length > 0;
      } else {
        hasError = !state.answers?.response?.[ele.id];
      }
      return {
        ...acc,
        [ele.id]: hasError
      };
    }, {}), [state.answers, allFields]);

  useEffect(() => {
    setErrors((prevErrors) => {
      const hasChanges = Object.keys(newFieldErrors).some(
        key => newFieldErrors[key] !== prevErrors[key]
      );
      return hasChanges ? { ...prevErrors, ...newFieldErrors } : prevErrors;
    });
  }, [newFieldErrors]); // Note: Only depend on `newFieldErrors`

  useEffect(() => {
    if (!renewalFields?.length) return;
    const newErrors = {};

    // ---------- helpers ----------
    const getValues = ids => state.answers?.renewal_response?.[ids];

    const isConditionMet = (field) => {
      if (!field.conditional) return true;
      const parentId = field.conditional_field?.key;
      const parentValue = getValues(parentId);
      if (parentValue === null) return false;
      if (Array.isArray(parentValue)) {
        return field.conditional_values?.some(cond => parentValue.includes(cond.value));
      }
      return field.conditional_values?.some(cond => cond.value === parentValue);
    };

    // ---------- renewal validation ----------
    renewalFields.forEach((field) => {
      const conditionMet = isConditionMet(field);
      if (!field.required || !conditionMet) {
        newErrors[field.id] = false;
        return;
      }
      const value = getValues(field.id);
      newErrors[field.id] = isEmptyValue(value, field.type);
    });

    // ---------- update renewal errors ----------
    setRenewalErrors(newErrors);
  }, [renewalFields, state.answers?.renewal_response]);


  useEffect(() => () => {
    // cleanup runs on unmount
    dispatch(clearState());
  }, [dispatch]);

  // clear the state after submitting
  useEffect(() => {
    if (submissionStatus?.loading === false && (submissionStatus.success === true)) {
      history.push('/adp/logs');
    }
    if (submissionStatus.error === true) setState({ ...state, loader: false });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submissionStatus, history, dispatch]);

  useEffect(() => {
    if (initiateDraftApplicationAction?.loading === false && initiateDraftApplicationAction.success === true) {
      dispatch(clearDraftState());
      history.push('/adp/logs');
    }
  }, [initiateDraftApplicationAction, dispatch, history]);

  useEffect(() => {
    let reqFieldError = {};
    if (reqAttach?.length > 0) {
      reqAttach.forEach((e) => {
        let name = e;
        if (typeof e === 'object') {
          name = e.attachmentName;
        }
        reqFieldError = {
          ...reqFieldError,
          [`${name}_attachments`]: (!state.answers?.req_attachments?.[`${name}_attachments`]?.length > 0)
        };
      });
      setReqErrors(reqFieldError);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.answers?.req_attachments, reqAttach]);

  const handleAnswerChanged = (section, answer, fieldId) => {
    if (conditionalFields?.[fieldId]) { // check the conditional fields
      conditionalFields[fieldId].forEach((item) => {
        const conditionValues = item?.conditional_values;
        const fieldValue = answer;
        const enableCondition = conditionValues.some(value => fieldValue === value?.value);
        const defaultValue = valueType(item)?.value;
        if (item.required) {
          handleFieldErrorChanged(
            item.id,
            enableCondition ? getValue(item, state?.answers) : false
          );
        }
        if (enableCondition) {
          setState(prev => ({
            ...prev,
            answers: {
              ...prev.answers,
              ...(adpDefaultIDs.includes(item.id)
                ? { [item.id]: getDefAnswer(item, state?.answers) }
                : { response: { ...prev.answers.response, [item.id]: getCusAns(item, state?.answers) } }
              )
            }
          }));
        } else {
          setState(prev => ({
            ...prev,
            answers: {
              ...prev.answers,
              ...(adpDefaultIDs.includes(item.id)
                ? { [item.id]: defaultValue }
                : { response: { ...prev.answers.response, [item.id]: defaultValue } }
              )
            }
          }));
        }
      });
    }
    if (section === 'response') { // check custom field answers
      setState(prevState => ({
        ...prevState,
        answers: {
          ...prevState.answers,
          response: {
            ...prevState.answers.response,
            [fieldId]: answer
          }
        }
      }));
    } else if (section === 'req_attachments') { // check required attachment answers
      setState(prevState => ({
        ...prevState,
        answers: {
          ...prevState.answers,
          req_attachments: {
            ...prevState.answers.req_attachments,
            [fieldId]: answer
          }
        }
      }));
    } else if (section === 'req_attachments_dates') {
      setState(prevState => ({
        ...prevState,
        answers: {
          ...prevState.answers,
          req_attachments_details: {
            ...prevState.answers.req_attachments_details,
            [section]: {
              ...prevState.answers.req_attachments_details?.[section],
              [fieldId]: answer
            }
          }
        }
      }));
    } else { // check default field answers
      setState(prevState => ({
        ...prevState,
        [section]: {
          ...prevState[section],
          [fieldId]: answer
        }
      }));
    }
  };

  const handleRenewalAnswerChanged = (answer, fieldId) => {
    setState(prevState => ({
      ...prevState,
      answers: {
        ...prevState.answers,
        renewal_response: {
          ...prevState.answers.renewal_response,
          [fieldId]: answer
        }
      }
    }));
  };

  const handleFieldErrorChanged = (fieldId, value) => {
    setErrors(prevErrors => ({ ...prevErrors, [fieldId]: value }));
  };

  const handleRenewalFieldErrorChanged = (fieldId, value) => {
    setRenewalErrors(prevErr => ({ ...prevErr, [fieldId]: value }));
  };

  const handleRemoveAttachments = (attachment) => {
    const filtereAttachments = state.answers?.attachments?.filter(e => e?.attachment_id !== attachment?.attachment_id);
    setState(prev => ({ ...prev, answers: { ...prev.answers, attachments: filtereAttachments } }));
  };

  // ----------- Attachment Upload function start -----------
  const handleUploadAttachments = async (attachments, entity) => {
    const attachmentIds = [];
    const newAttachments = [];
    const oldAttachments = [];
    attachments.forEach((e) => {
      if (!e.id) {
        newAttachments.push(e);
      } else if (e.id && e.name) {
        oldAttachments.push(e.name);
      }
    });
    let fileIds = '';
    if (newAttachments.length > 0) {
      fileIds = await getFileNames(newAttachments?.length);
    }
    if (fileIds) {
      await doS3Upload(
        newAttachments,
        fileIds,
        entity || 'driver_permit',
        getErrorAlert
      ).then(() => {
        fileIds.filename.forEach((i) => {
          attachmentIds.push(i.toString());
        });
      });
    }
    if (oldAttachments.length > 0) {
      attachmentIds.push(...oldAttachments);
    }
    return attachmentIds;
  };

  const uploadtoS3 = async (attachments) => {
    let fileIds = '';
    fileIds = await getFileNames(attachments.length);
    const list = [];
    if (fileIds) {
      await doS3Upload(attachments, fileIds, 'driver_permit', getErrorAlert)
        .then((res) => {
          res.forEach((ele) => {
            list.push(ele?.id?.toString());
          });
        });
    }
    return list;
  };

  const getFileNames = async (count) => {
    const response = await GetFileName.getPermitUploadFileName(count);
    return response;
  };

  const doS3Upload = async (files, fileIds, entity, getErrorAlert) => {
    const response = await S3Uploads.uploadFiles(
      files,
      fileIds.filename,
      entity,
      installationId,
      airportCode,
      getErrorAlert
    );
    return response;
  };

  // ----------- Attachment Upload functions end -----------

  const handelSubmit = async (isDraft = false) => {
    const { lic_exp_date, lic_issue_date, dob } = state.answers;
    setIsAlreadySubmited(false);
    // Validate inputs
    const error = validateInputs(state.answers, errors, reqAttach);
    const noErrors = Object.values(error).every(value => value === false);
    const noReqErrors = Object.values(reqErrors).every(value => value === false);
    const noRenwalErrors =renewalFields? Object.values(renewalErrors).every(value => value === false): true;
    const dateError = validateDates({ dob, lic_issue_date, lic_exp_date });
    if (!isDraft && dateError) {
      setState(prev => ({ ...prev, dateError }));
      return;
    }
    if (!isDraft && noErrors && noReqErrors && noRenwalErrors) {
        await submitApplicationData();
    } else if (isDraft) {
        await submitApplicationData(isDraft);
    } else {
        setState(prev => ({ ...prev, formErrors: true, dateError: false }));
    }
  };

  const validateInputs = (answers, errorList, reqAttachs) => ({
    ...errorList,
    attachments: !reqAttachs?.length > 0 ? !answers.attachments?.length : false,
    signature: !answers.signature,
    photo: !answers?.photo?.length > 0
  });

  const validateDates = ({ dob, lic_issue_date, lic_exp_date }) => {
    const currentDate = moment().startOf('day');
    const issueDate = lic_issue_date ? moment(lic_issue_date) : null;
    const expireDate = lic_exp_date ? moment(lic_exp_date) : null;
    const dateOfBirth = dob ? moment(dob) : null;

    if (issueDate?.isAfter(currentDate)) {
      return 'License Issue Date cannot be a future date. Please modify the date and try again.';
    }
    if (expireDate?.isBefore(currentDate)) {
      return 'License Expire Date should be a future date. Please modify the date and try again.';
    }
    if (issueDate && expireDate && issueDate.isAfter(expireDate)) {
      return 'License Issued date should not be older than License Expiry date.';
    }
    if (dateOfBirth && currentDate.diff(dateOfBirth, 'year') < 17) {
      return 'Applicant age should be 17 years or above.';
    }
    return null;
  };

  const handleConfirmDelete = () => {
    setConfirmDelete(true);
  };

  const toggleConfirmDelete = () => {
    setConfirmDelete(!confirmDelete);
  };

  const remove = () => {
    dispatch(deleteSaveAsDraftAdpLog(userData.id));
    setConfirmDelete(false);
  };

  const goToLogs = () => {
    history.push('/adp/logs');
  };

  const submitApplicationData = async (isDraftApp = false) => {
    const {
      attachments,
      signature,
      photo,
      req_attachments
    } = state.answers;
    setState({
        ...state,
        loader: true,
        dateError: ''
    });

    const attchList = reqAttach?.length > 0 && Object.entries(req_attachments || {}).reduce((acc, [key, attachment]) => {
      if (Array.isArray(attachment)) {
        acc[key] = attachment
          .map(item => item?.attachment_id)
          .filter(aid => typeof aid === 'string');
      } else {
        acc[key] = [];
      }
      return acc;
    }, {});
    const attachmentId = (!reqAttach?.length > 0 && attachments?.length > 0)
      ? attachments.map(item => item?.attachment_id).filter(aid => typeof aid === 'string')
      : [];
    const photoId = (photo?.length > 0 && Array.isArray(photo))
      ? photo.map(item => item?.attachment_id).filter(pid => typeof pid === 'string')
      : [];

    const signatureId = await handleSignature(signature, handleUploadAttachments, uploadtoS3, 'driver_permit');

    await uploadCustomAttachments();

    await uploadCustomSignature();

    if (renewalFields) {
      await uploadRenewalAttachments();
    }
    const dataObject = payloadDataObject({
        attchList,
        attachmentId,
        photoId,
        signatureId,
        isDraftApp
    });
    finalSubmit(dataObject, isDraftApp);
  };

  const uploadCustomAttachments = async () => {
    const attachmentFields = customFields.filter(
        schemaField => schemaField?.type === 'attachments'
    );
    const uploadingAttachments = attachmentFields.map(async (schemaField) => {
      const attachmentField = schemaField?.id;
      if (schemaField?.type === 'attachments' && state.answers?.response?.[attachmentField]?.length > 0) {
        state.answers.response[attachmentField] = state.answers.response[attachmentField]
          .map(item => item?.attachment_id)
          .filter(rid => typeof rid === 'string');
      }
    });
    await Promise.all(uploadingAttachments);
  };

  const uploadCustomSignature = async () => {
    const signatureFields = customFields.filter(schemaField => schemaField?.type === 'signature');

    const uploadingSignature = signatureFields?.map(async (schemaField) => {
      const signatureField = schemaField?.id;
      const value = state.answers?.response?.[signatureField]
          ? [state.answers.response[signatureField]]
          : [];

      const signatureValue = Array.isArray(state.answers?.response?.[signatureField])
        ? state.answers.response[signatureField]
        : value;

      if (signatureValue.length > 0) {
        state.answers.response[signatureField] = (await handleUploadAttachments(signatureValue, 'driver_permit')) || [];
      }
    });

    await Promise.all(uploadingSignature);
  };

  const uploadRenewalAttachments = async () => {
    const attachmentFields = renewalFields.filter(
        schemaField => schemaField?.type === 'attachments'
    );
    const uploadingAttachments = attachmentFields.map(async (schemaField) => {
      const attachmentField = schemaField?.id;
      if (schemaField?.type === 'attachments' && state.answers?.renewal_response?.[attachmentField]?.length > 0) {
        state.answers.renewal_response[attachmentField] = state.answers.renewal_response[attachmentField]
          .map(item => item?.attachment_id)
          .filter(rid => typeof rid === 'string');
      }
    });
    await Promise.all(uploadingAttachments);
  };

  const payloadDataObject = ({ attchList, attachmentId, photoId, signatureId, isDraftApp }) => {
    const { answers } = state;
    const adp_category_id = adpCategories?.find(ele => ele.name === state.answers?.category_of_adp);
    return {
      ...answers,
      application_type: 'Renewal',
      photo: photoId,
      attachments: attachmentId,
      admin_response: answers.admin_response ? getAttachmentIds(answers.admin_response) : {},
      req_attachments: attchList,
      signature: signatureId?.[0] || [],
      adp_category: adp_category_id?.id || null,
      prev_permit: userData?.id ? userData?.id : null,
      status: isDraftApp ? 'Draft' : null,
      prev_badge_no: state?.answers?.use_prev_badge
        ? userData?.badge_no
        : null,
      dob: answers.dob
        ? moment(answers.dob).format('YYYY-MM-DD')
        : answers.dob,
      lic_exp_date: answers.lic_exp_date
        ? moment(answers.lic_exp_date).format('YYYY-MM-DD')
        : answers.lic_exp_date,
      lic_issue_date: answers.lic_issue_date
        ? moment(answers.lic_issue_date).format('YYYY-MM-DD')
        : answers.lic_issue_date
    };
  };

  const finalSubmit = (dataObject, isDraftApp) => {
    let data = { ...dataObject };
    if (data.photo?.length) {
        data.attachments.push(...data.photo);
    }
    if (reqAttach?.length > 0 && Object.keys(data.req_attachments || {})?.length > 0) {
        data.attachments.push(...Object.values(data.req_attachments).flat());
    }
    const checkboxFields = allFields.filter(field => field.type === 'boolean');
    checkboxFields.forEach((field) => {
      if (!data.response[field.id]) {
        data.response[field.id] = false;
      }
    });

    if ((userData?.status === 14 && !isDraftApp) || (userData?.status === 14 && isDraftApp)) {
      dispatch(initiateDraftPermit(data, userData.id));
    } else {
      dispatch(initiateApplication(data));
    }
  };

  const getErrorAlert = value => setAlert(value);

  const getLoadingStatus = value => setLoad(value);

  // Helper function to get answers
  const getAnswers = fieldId => (
    adpDefaultIDs.includes(fieldId)
    ? state.answers[fieldId]
    : state.answers.response?.[fieldId]);

  // Build the answers object using a loop
  const fieldAnswers = {};
  allFields.forEach((field) => {
    fieldAnswers[field.id] = getAnswers(field.id);
  });

  return (
    <>
      <SectionHeader
        icon={permitIcon}
        translationID=" "
        defaultTitle={`Renewal ${userProfile.permit_management?.driver_permit || 'Airside Driving Permit'}`}
      />
      <HeaderBack
        translationID="workorder.settings.back"
        translationDefault="Back"
        backRoute={`/adp/detail/${id}`}
        exactRoute
      />
      <div className={styles.container}>
        <Loading loadingStatus={state.loader || getSchemaStatus?.loading || !allFields?.length > 0
          || initiateDraftApplicationAction?.loading
        } />
        <div className={styles.headder}>
          <FormattedMessage
            id=" "
            defaultMessage="Renewal Application"
          />
        </div>
        <div className={styles.childContainer}>
          {
            renderFieldComponent(
              state,
              notes,
              errors,
              reqAttach,
              allFields,
              fieldAnswers,
              handleAnswerChanged,
              handleRemoveAttachments,
              handleFieldErrorChanged,
              uploadtoS3,
              getLoadingStatus,
              'driver_permit',
              renewalFields,
              renewalErrors,
              handleRenewalAnswerChanged,
              handleRenewalFieldErrorChanged,
              'Renewal'
            )
          }
          <label htmlFor="adp_number">
            <input
              type="checkbox"
              id="adp_number"
              style={{ margin: '0 5px' }}
              onChange={(e) => {
                setState(prevState => ({ ...prevState,
                  answers: {
                    ...state.answers,
                    use_prev_badge: e.target.checked
                  }
                }));
              }}
              value={state.answers.use_prev_badge}
            />
              <FormattedMessage
                id="permit.use_same_permit"
                defaultMessage="Use Same Permit Number"
              />
          </label>
        </div>
        <div className={styles.submitButton} style={{ justifyContent: `${state.dateError || state.formErrors
          || isAlreadySubmited === true ? 'space-between': 'flex-end'}` }}>
          <p className={styles.errorMessage}>
            {state.dateError}
            {(!state.dateError && state.formErrors) && isAlreadySubmited === false && (
              <FormattedMessageWithClass
                id=" "
                defaultMessage="* Please fill all the required fields" />
            )}
            {(isAlreadySubmited === true && !state.dateError) && (
              <FormattedMessageWithClass
                id=" "
                defaultMessage="A Renewal Application is Already In Progress. Please Cancel This." />
            )}
          </p>
          <div style={{ display: 'flex', gap: '16px' }}>
            <Button
              action="tertiary"
              onClick={() => { history.push(`/adp/detail/${id}`); setIsAlreadySubmited(false); }}
              translationID="inspections.new.cancelBtn"
              defaultText="Cancel"
            />
            {userData && userData?.status === 14 && (
              <Button
                action="danger"
                onClick={() => handleConfirmDelete()}
                translationID="assets.delete"
                defaultText="Delete"
              />
            )}
            <Button
              action="primary"
              onClick={() => handelSubmit(true)}
              translationID="inspections.complete_inspections.save_as_draft"
              defaultText="Save as Draft"
              disabled={load}
            />
            <Button
              action="secondary"
              onClick={() => (handelSubmit())}
              translationID="adp.submit"
              defaultText="Submit"
              disabled={load}
            />
          </div>
        </div>
        <DeleteConfirmation
          isActive={confirmDelete}
          onClose={() => toggleConfirmDelete()}
          confirmDelete={() => remove()}
        />
        {alert && <SaveAlert alert={alert} setAlert={setAlert} handelSubmit={() => handelSubmit(true)} />}
      </div>
    </>
  );
};

export default RenewalAdminForm;
